<p-accordion-panel [value]="index()">
  <p-accordion-header>
    <div class="me-4 flex flex-1 items-center justify-between gap-4">
      <div class="flex items-center gap-2 text-sm text-gray-400">
        <span>{{ panelCount() }}</span>
        <span>{{ currentName$ | async | noData }}</span>
      </div>

      <div>
        @if (shouldRemove()) {
          <p-button
            (onClick)="handleProductRemoveClick()"
            severity="danger"
            label="Usuń"
            appPrimengButton />
        }
      </div>
    </div>
  </p-accordion-header>

  <p-accordion-content>
    <div class="grid grid-cols-2 gap-4">
      <app-form-control label="Produkt">
        <p-select
          (onFilter)="handleSelectFilterChange($event)"
          [filter]="true"
          [formControl]="productFormGroup().controls.id"
          [options]="valueOrDefault(productSelectItems$ | async, [])"
          appPrimengSelect
          [fluid]="true"
          placeholder="Wybierz produkt" />
      </app-form-control>

      <app-form-control label="Ilość">
        <input
          [formControl]="productFormGroup().controls.quantity"
          pInputText
          placeholder="Wprowadź ilość"
          type="number" />
      </app-form-control>
    </div>
  </p-accordion-content>
</p-accordion-panel>
